
  const header = document.getElementById('header');
  const burger = document.getElementById('burger');

  // burger.addEventListener('click', () => {
  //   header.classList.toggle('active');
  // })

  window.addEventListener('scroll', () => {
      if(window.scrollY > 100) {
        header.classList.add('tiny');
      } 
      else{
        header.classList.remove('tiny');
      }
  })

  /*## Open & close menu mobile ##*/
  $('#hamburger__button').on("click",function(e){

    if($(this).hasClass('hamburger--arrow')){

        $('.sub-menu').removeClass('menu_open');
        $('.hamburger').removeClass('hamburger--arrow');
        $('.hamburger').addClass('hamburger--spin');

    }else{

      $(this).toggleClass('is-active');
    
      if($(this).hasClass('is-active')){
        $(".header__nav").addClass("show-menu");
      }else{
        $(".header__nav").removeClass("show-menu");  
      }

    }
    
  });

  /*## Open submenu mobile ##*/
  $('.menu-item-has-children>a').on("click",function(e){
    
    e.preventDefault();

    var parent_link = $(this).parent();
    var submenu = $(parent_link).children('.sub-menu');

    $(submenu).addClass('menu_open');
    $('.hamburger').removeClass('hamburger--spin');
    $('.hamburger').addClass('hamburger--arrow');

  });

  /** Reglementation modals */

  $('.buttons .open-modal').on('click', function(e) {
    const idModal = $(this).attr('data-modal');
    $('#'+idModal).show('slide');
    $('html, body').css('overflow', 'hidden')
  })
  $('.modal-section .close-modal').on('click', function(e) {
    $(this).parent().parent('.modal-section').hide('slide');
    $('html, body').css('overflow', 'auto')
  })

  /** END Reglementation modals */


    
  const scrollDown = document.getElementById('scrollDown');

  if(scrollDown){
      let scrolloffset = 0;
      scrollDown.addEventListener('click', () => {
          window.scrollTo({
              top: window.innerHeight - scrolloffset,
              left: 0,
              behavior: 'smooth'
          });
      })
  }

  $('.gallery_inside-slider').slick({
    slidesToShow: 4,
    dots: true,
    slidesToScroll: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });

  $('#banner_slider').slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
    });

  $('#slider').slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $('.slider__prev'),
      nextArrow: $('.slider__next'),
      responsive: [
        {
          breakpoint: 1550,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
      ]
    });

    
    
    $('article.bloc_txt.readmore').readmore({
      moreLink: '<a href="#" class="btn-read link big"><span>Lire plus</span></a>',
      lessLink: '<a href="#" class="btn-read link big"><span>Fermer</span></a>',
      embedCSS: false,
      collapsedHeight: 300
    });



    